import React, { useState, useEffect } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import InstallIcon from "@mui/icons-material/GetApp";

const PwaInstallPrompt = () => {
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowInstallPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
      });
    }
  };

  return (
    <>
      {showInstallPrompt && (
        <div style={popupStyle} className="ljustify-content-center" textAlign="center">
          <Tooltip title="Install App" placement="bottom" >
            <IconButton
              onClick={handleInstallClick}
              sx={{
                backgroundColor: "#4caf50",
                color: "#fff",
                borderRadius: "50%",
                padding: "10px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                "&:hover": {
                  transform: "scale(1.1)",
                  backgroundColor: "#388e3c",
                },
              }}
            >
              <InstallIcon />
            </IconButton>
            <Typography
            variant="caption"
            textAlign="center"
            display="flex"
            sx={{ mb: 1, color: "#616161" }}
          >
            Install
          </Typography>
          </Tooltip>
         
        </div>
      )}
    </>
  );
};

const popupStyle = {
  position: "fixed",
  bottom: "16%",
  left: "85%",
  zIndex: 1500,
  padding: "px",
};

export default PwaInstallPrompt;
